import { GET_TALOAD_REQUEST, GET_TALOAD_SUCCESS, GET_TALOAD_FAILUER } from "./types"

const initialState = {
    loading: false,
    error: null,
    
    gettaloadlist: []
}
const gettaloadresucer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TALOAD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case GET_TALOAD_SUCCESS: {
            
            return {
                ...state,
                loading: false,
                gettaloadlist: action.payload
            }
        }
        case GET_TALOAD_FAILUER:
            return {
                ...state,
                loading: false,
                // error: action.payload.message,
            }

        default:
            return state
    }
}

export default gettaloadresucer